import './Shine.css';

export type ShineVariant = 'delivery' | 'welcome';

export type ShineProps = {
  variant?: ShineVariant;
  className?: string;
};

/** Warm overlay glow — delivery (Figma shine) or welcome (DecorShine ellipses). */
export function Shine({ variant = 'delivery', className }: ShineProps) {
  const extra = className ? ` ${className}` : '';

  return (
    <>
      <div
        className={`shine__ellipse shine__ellipse--${variant} shine__ellipse--1${extra}`}
        aria-hidden
      />
      <div
        className={`shine__ellipse shine__ellipse--${variant} shine__ellipse--2${extra}`}
        aria-hidden
      />
    </>
  );
}
